import { CookieConsentType } from '../components/CookieConsent/cookieConsent.type'
import { data as cookieConsentData } from '../components/CookieConsent/templateData/default'

import { CategoriesBannerType } from '../components/CategoriesBanner/categoriesBanner.type'

import { TopMobileBannerType } from '../components/TopMobileBanner/topMobileBanner.type'

import {
  ShopByCharactersType,
  defaultData as shopByCharactersData,
} from '../components/ShopByCharacters/shopByCharacters.type'

import {
  CategoriesMobileCarouselType,
  defaultData as categoriesMobileCarouselData,
} from '../components/CategoriesMobileCarousel/categoriesMobileCarousel.type'

import { ElementType } from '../components/Element/element.type'

import {
  FooterButtonsType,
  defaultData as footerButtonsData,
} from '../components/FooterButtons/footerButtons.type'

import { ListingPageType } from '../components/ListingPage/listingPage.type'

import { MenuLayoutType } from '../components/MenuLayout/MenuLayout.type'
import { BottomMenuEnum } from '../components/MenuLayout/MenuLayout.props'
import {
  navbarData,
  suggestedData,
} from '../components/MenuLayout/templateData/navbar'
import { footerData } from '../components/MenuLayout/templateData/footer'

import { ProductsCarouselType } from '../components/ProductsCarousel/productsCarousel.type'

import { SeoModuleType } from '../components/SeoModule/seomodule.type'

import {
  ShopByAgeType,
  defaultData as shopByAgeDefaultData,
} from '../components/ShopByAge/shopByAge.type'
import { ErrorPageProps } from '../components/ErrorPage/errorPage.props'

import { BlogPageType } from '../components/BlogPage/blogPage.type'
import { BrandsCarouselProps } from '../components/BrandsCarousel/brandsCarousel.props'
import { BrandsCarouselType } from '../components/BrandsCarousel/brandsCarousel.type'

import {
  AggregationTypeEnum,
  ComponentTypeEnum,
} from '@sentecacommerce-theme/lib'
const sortOptions = [
  {
    key: 'default-desc',
    label: 'По подразбиране',
  },
  {
    key: 'price-asc',
    label: 'Цена възх.',
  },
  {
    key: 'price-desc',
    label: 'Цена низх.',
  },
  {
    key: 'discount-asc',
    label: 'Отстъпка възх.',
  },
  {
    key: 'discount-desc',
    label: 'Отстъпка низх.',
  },
]

const defaultSortKey = 'default-desc'

export const brandsData: BrandsCarouselProps = {
  data: [
    {
      url:
        'https://production.hippoland-contents.com/platform/media/1614834963695-bakugan-6007d7f82d767c61246b45bd.jpg',
      href: '/bakugan/b',
    },
    {
      url:
        'https://production.hippoland-contents.com/platform/media/1614834829684-barbie-6007d7f82d767c61246b45bd.png',
      href: '/barbie/b',
    },
    {
      url:
        'https://production.hippoland-contents.com/platform/media/1614834844309-ben-10-6007d7f82d767c61246b45bd.png',
      href: '/ben-10/b',
    },
    {
      url:
        'https://production.hippoland-contents.com/platform/media/1614834864162-bruder_1-6007d7f82d767c61246b45bd.png',
      href: '/bruder/b',
    },
    {
      url:
        'https://production.hippoland-contents.com/platform/media/1614834845536-cars-6007d7f82d767c61246b45bd.png',
      href: '/cars/b',
    },
    {
      url:
        'https://production.hippoland-contents.com/platform/media/1614834836617-clementoni-6007d7f82d767c61246b45bd.png',
      href: '/clementoni/b',
    },
    {
      url:
        'https://production.hippoland-contents.com/platform/media/1614834959915-cry-babies-6007d7f82d767c61246b45bd.jpg',
      href: '/crybabies/b',
    },
    {
      url:
        'https://production.hippoland-contents.com/platform/media/1614834889246-disney-prinsess-6007d7f82d767c61246b45bd.png',
      href: '/disney-princess/b',
    },
    {
      url:
        'https://production.hippoland-contents.com/platform/media/1614834835397-fisher-price-6007d7f82d767c61246b45bd.png',
      href: '/fisher-price/b',
    },
    {
      url:
        'https://production.hippoland-contents.com/platform/media/1614834831497-hot-wheels-6007d7f82d767c61246b45bd.png',
      href: '/hot-wheels/b',
    },
    {
      url:
        'https://production.hippoland-contents.com/platform/media/1614834838830-lego-logo0810-6007d7f82d767c61246b45bd.jpg',
      href: '/lego/b',
    },
    {
      url:
        'https://production.hippoland-contents.com/platform/media/1614834830587-maisto-6007d7f82d767c61246b45bd.png',
      href: '/maisto/b',
    },
    {
      url:
        'https://production.hippoland-contents.com/platform/media/1614834846767-nerf-6007d7f82d767c61246b45bd.png',
      href: '/nerf/b',
    },
    {
      url:
        'https://production.hippoland-contents.com/platform/media/1614834970901-power_players_146x146_logos-01_for-web-6007d7f82d767c61246b45bd.jpg',
      href: '/power-players/b',
    },
  ],
}
const ErrorPageData: ErrorPageProps = {
  title: '404',
  subTitle: 'Страницата не е намерена',
  content:
    'Съжаляваме, но страницата, която търсите не съществува или е била преместена.',
  ctaLabel: 'Към начало',
  ctaLink: '/',
  image: 'https://www.hippoland.net/media/wysiwyg/404-banner.jpg',
  searchPlaceholder: 'Търсене',
  suggestedLinks: {
    title: 'Полезни връзки',
    links: [
      {
        name: 'Контакти',
        url: '/contacts',
      },
      {
        name: 'Акция',
        url: '/action/v',
      },
      {
        name: 'Най-ново',
        url: '/naj-novo/c',
      },
      {
        name: 'Марки',
        url: '/brands',
      },
    ],
  },
}

export const Templates = {
  CookieConsentTemplate: CookieConsentType.addTemplate(
    'CookieConsentDefault',
    cookieConsentData
  ),
  CategoriesBannerTemplate: CategoriesBannerType.addTemplate(
    'CategoriesBannerDefault',
    {
      data: [
        {
          images: [
            {
              url:
                '/produkti-kantselarski-materiali-ranitsi-chanti-i-neseseri/c?sort=discount-desc',
              image:
                'https://production.hippoland-contents.com/platform/media/400x400px_ranici-61405e0ec3165700116a5c37.jpg',
              header: 'Раници, чанти и несесери',
              imageWidth: 600,
              imageHeight: 600,
            },
          ],
          default: {
            alt: 'Банер',
            ariaLabel: 'Банер',
          },
        },
        {
          images: [
            {
              url:
                '/produkti-kantselarski-materiali-uchenicheski-prinadlejnosti/c?sort=discount-desc',
              image:
                'https://production.hippoland-contents.com/platform/media/400x400px_uchenicheski-61405e0ec3165700116a5c37.jpg',
              header: 'Ученически пособия',
              imageWidth: 600,
              imageHeight: 600,
            },
          ],
          default: {
            alt: 'Банер',
            ariaLabel: 'Банер',
          },
        },
        {
          images: [
            {
              url: '/produkti-detski-igrachki-igri/c?sort=discount-desc',
              image:
                'https://production.hippoland-contents.com/platform/media/400x400px_svobodni_dni-61405e0ec3165700116a5c37.jpg',
              header: 'Игри',
              imageWidth: 600,
              imageHeight: 600,
            },
          ],
          default: {
            alt: 'Банер',
            ariaLabel: 'Банер',
          },
        },
        {
          images: [
            {
              url:
                '/produkti-detski-igrachki-obrazovatelni/c?sort=discount-desc',
              image:
                'https://production.hippoland-contents.com/platform/media/400x400px_igra_znanie-61405e0ec3165700116a5c37.jpg',
              header: 'Наука',
              imageWidth: 600,
              imageHeight: 600,
            },
          ],
          default: {
            alt: 'Банер',
            ariaLabel: 'Банер',
          },
        },
      ],
    }
  ),

  TopMobileBannerTemplate: TopMobileBannerType.addTemplate(
    'TopMobileBannerDefault',
    {
      url: '/lego/b',
      imageWidth: 1380,
      imageHeight: 1444,
      image:
        'https://production.hippoland-contents.com/platform/media/1380х1444px_obsht-61405e0ec3165700116a5c37.jpg',
      alt: 'Главен мобилен банер',
    }
  ),
  ShopByCharactersTemplate: ShopByCharactersType.addTemplate(
    'ShopByCharactersDefault',
    {
      ...shopByCharactersData,
      labels: {
        findYourFavChar: 'Намери своя любим герой',
      },
    }
  ),
  CategoriesMobileCarouselTemplate: CategoriesMobileCarouselType.addTemplate(
    'CategoriesMobileCarouselDefault',
    {
      ...categoriesMobileCarouselData,
    }
  ),
  BrandsCarouselTemplate: BrandsCarouselType.addTemplate(
    'BrandsCarouselDefault',
    {
      ...brandsData,
    }
  ),
  ElementTemplates: {
    container: ElementType.addTemplate('Container', {
      className: 'container mt-5 mt-lg-5 pt-lg-4',
    }),
    containerFluid: ElementType.addTemplate('Container fluid', {
      className: 'container-fluid mt-5 pt-4',
    }),

    row: ElementType.addTemplate('Row', {
      className: 'row g-3',
    }),

    col: ElementType.addTemplate('Col', {
      className: 'col',
    }),
  },
  FooterButtonsTemplate: FooterButtonsType.addTemplate('FooterButtonsDefault', {
    ...footerButtonsData,
  }),
  BlogPageTemplate: BlogPageType.addTemplate('default', {
    categories: {
      title: 'Категории',
      categoriesList: [
        {
          label: 'Полезно',
          tag: 'Полезно',
          slug: 'polezno',
        },
        {
          label: 'Съвети',
          tag: 'Съвети',
          slug: 'suveti',
        },
        {
          label: 'Забавно',
          tag: 'Забавно',
          slug: 'zabavno',
        },
      ],
    },
    labels: {
      title: 'Блог',
      readMore: 'Прочети още',
    },
    isDev: true,
    defaultMetaDescription:
      'В онлайн магазин Хиполенд ще намериш над 20000 артикула за бебета и деца: играчки, дрехи, обувки, колички, превозни средства и други. Купи онлайн!',
  }),

  ListingPageTemplates: {
    category: ListingPageType.addTemplate('Category', {
      seoAggregates: {
        label: 'Categories',
        aggregationType: AggregationTypeEnum.Terms,
        aggregationDefinition: 'subCategories',
        filterDefinition: 'category',
        component: ComponentTypeEnum.TextWithLink,
        order: 0,
      },
      labels: {
        filters: 'Филтри',
        selectedFiltersTitle: 'Избрани филтри',
        selectedFiltersBtnTxt: 'Изчисти',
        labelUnder: 'под',
        labelOver: 'над',
        labelBgn: 'лв',
        product: 'продукт',
        products: 'продукта',
        filterCallToAction: 'Филтрирай',
        sortCallToAction: 'Сортирай',
        searchingFor: 'за търсене по',
        searchIn: 'Търсете в',
        results: 'резултата',
        buyFromHippolandSentence: {
          start: 'Търсиш',
          end:
            '➦ Купи сега от онлайн магазин Хиполенд ✓ Бърза доставка в България ✓ Безплатна доставка над 65.00 лв. 02 / 40 484',
        },
        breadcrumbSentence: {
          start: 'Търсене за',
          end: '...',
        },
      },
      sortOptions,
      defaultSortKey,
      aggregates: [
        {
          label: 'Марки',
          aggregationType: AggregationTypeEnum.Terms,
          aggregationDefinition: 'brands',
          filterDefinition: 'brand',
          order: 0,
          component: ComponentTypeEnum.Autocomplete,
        },
        {
          label: 'Възраст',
          aggregationType: AggregationTypeEnum.Terms,
          aggregationDefinition: 'attr.age',
          filterDefinition: 'attr.age',
          order: 1,
          component: ComponentTypeEnum.AttributeCheckbox,
        },
        {
          label: 'Цена',
          aggregationType: AggregationTypeEnum.Ranges,
          aggregationDefinition: 'price:*-500,500-1000,1000-5000,5000-*',
          filterDefinition: 'price',
          order: 2,
          component: ComponentTypeEnum.RangeCheckbox,
        },
      ],
      notFound: {
        ...ErrorPageData,
        subTitle: 'Категорията не е намерена',
        content:
          'Съжаляваме, но категорията, която търсите не съществува или е била преместена.',
        suggestedLinks: {
          title: 'Полезни връзки',
          links: [
            {
              name: 'Контакти',
              url: '/contacts',
            },
            {
              name: 'Акция',
              url: '/action/v',
            },
            {
              name: 'Най-ново',
              url: '/naj-novo/c',
            },
            {
              name: 'Марки',
              url: '/brands',
            },
          ],
        },
      },
      SEO: {
        titleTemplate: ':name: | Oтлични цени | Онлайн Магазин — ХИПОЛЕНД',
        descriptionTemplate:
          'Търсиш :name::selected_filters:? ➦ Купи сега от онлайн магазин ✅ Хиполенд ✓ Бърза доставка в България ✓ Безплатна доставка над 65.00 лв. ☎ 02 / 40 484',
        favorDescriptionTemplateOverMeta: false,
        favorTitleTemplateOverMeta: false,
      },
    }),
    brand: ListingPageType.addTemplate('Brand', {
      seoAggregates: {
        label: 'Категории',
        aggregationType: AggregationTypeEnum.Terms,
        aggregationDefinition: 'subBrands',
        filterDefinition: 'brand',
        component: ComponentTypeEnum.TextWithLink,
        order: 0,
      },
      labels: {
        filters: 'Филтри',
        selectedFiltersTitle: 'Избрани филтри',
        selectedFiltersBtnTxt: 'Изчисти',
        labelUnder: 'под',
        labelOver: 'над',
        labelBgn: 'лв',
        product: 'продукт',
        products: 'продуктa',
        filterCallToAction: 'Филтрирай',
        sortCallToAction: 'Сортирай',
        searchingFor: 'за търсене по',
        searchIn: 'Търсете в',
        results: 'резултата',
        buyFromHippolandSentence: {
          start: 'Търсиш',
          end:
            '➦ Купи сега от онлайн магазин Хиполенд ✓ Бърза доставка в България ✓ Безплатна доставка над 65.00 лв. 02 / 40 484',
        },
        breadcrumbSentence: {
          start: 'Търсене за',
          end: '...',
        },
      },
      sortOptions,
      defaultSortKey,
      aggregates: [
        {
          label: 'Категории',
          aggregationType: AggregationTypeEnum.Terms,
          aggregationDefinition: 'categories',
          filterDefinition: 'category',
          order: 0,
          component: ComponentTypeEnum.Checkbox,
        },
        {
          label: 'Възраст',
          aggregationType: AggregationTypeEnum.Terms,
          aggregationDefinition: 'attr.age',
          filterDefinition: 'attr.age',
          order: 1,
          component: ComponentTypeEnum.AttributeCheckbox,
        },
        {
          label: 'Цена',
          aggregationType: AggregationTypeEnum.Ranges,
          aggregationDefinition: 'price:*-500,500-1000,1000-5000,5000-*',
          filterDefinition: 'price',
          order: 2,
          component: ComponentTypeEnum.RangeCheckbox,
        },
      ],
      notFound: {
        ...ErrorPageData,
        subTitle: 'Марката не е намерена',
        content:
          'Съжаляваме, но марката, която търсите не съществува или е била преместена.',
      },
      SEO: {
        titleTemplate: ':name: | Играчки | Детски стоки — ХИПОЛЕНД',
        descriptionTemplate:
          'Купете ➤ Продукти за деца с марка :name: на добри цени от ✅ Хиполенд ✓ Безплатна доставка в България над 49.00 лв. ☎ 02 / 40 484',
        favorDescriptionTemplateOverMeta: false,
        favorTitleTemplateOverMeta: false,
      },
    }),
    view: ListingPageType.addTemplate('View', {
      sortOptions,
      defaultSortKey,
      labels: {
        filters: 'Филтри',
        selectedFiltersTitle: 'Избрани филтри',
        selectedFiltersBtnTxt: 'Изчисти',
        labelUnder: 'под',
        labelOver: 'над',
        labelBgn: 'лв',
        product: 'продукт',
        products: 'продукта',
        filterCallToAction: 'Филтрирай',
        sortCallToAction: 'Сортирай',
        searchingFor: 'за търсене по',
        searchIn: 'Търсете в',
        results: 'резултата',
        buyFromHippolandSentence: {
          start: 'Търсиш',
          end:
            '➦ Купи сега от онлайн магазин Хиполенд ✓ Бърза доставка в България ✓ Безплатна доставка над 65.00 лв. 02 / 40 484',
        },
        breadcrumbSentence: {
          start: 'Търсене за',
          end: '...',
        },
      },
      aggregates: [
        {
          label: 'Категории',
          aggregationType: AggregationTypeEnum.Terms,
          aggregationDefinition: 'categories',
          filterDefinition: 'category',
          order: 0,
          component: ComponentTypeEnum.Checkbox,
        },
        {
          label: 'Марки',
          aggregationType: AggregationTypeEnum.Terms,
          aggregationDefinition: 'brands',
          filterDefinition: 'brand',
          order: 1,
          component: ComponentTypeEnum.Autocomplete,
        },
        {
          label: 'Възраст',
          aggregationType: AggregationTypeEnum.Terms,
          aggregationDefinition: 'attr.age',
          filterDefinition: 'attr.age',
          order: 2,
          component: ComponentTypeEnum.AttributeCheckbox,
        },
        {
          label: 'Цена',
          aggregationType: AggregationTypeEnum.Ranges,
          aggregationDefinition: 'price:*-500,500-1000,1000-5000,5000-*',
          filterDefinition: 'price',
          order: 3,
          component: ComponentTypeEnum.RangeCheckbox,
        },
      ],
      notFound: ErrorPageData,
      SEO: {
        titleTemplate: ':name: | Oтлични цени | Онлайн Магазин — ХИПОЛЕНД',
        descriptionTemplate:
          ':name: ➦ Купи сега от онлайн магазин ✅ Хиполенд ✓ Бърза доставка в България ✓ Безплатна доставка над 65.00 лв. ☎ 02 / 40 484',
        favorDescriptionTemplateOverMeta: false,
        favorTitleTemplateOverMeta: false,
      },
    }),
    search: ListingPageType.addTemplate('Search', {
      sortOptions,
      defaultSortKey,
      labels: {
        filters: 'Филтри',
        selectedFiltersTitle: 'Избрани филтри',
        selectedFiltersBtnTxt: 'Изчисти',
        labelUnder: 'под',
        labelOver: 'над',
        labelBgn: 'лв',
        product: 'продукт',
        products: 'продукта',
        filterCallToAction: 'Филтрирай',
        sortCallToAction: 'Сортирай',
        searchingFor: 'за търсене по',
        searchIn: 'Търсете в',
        results: 'резултата',
        buyFromHippolandSentence: {
          start: 'Търсиш',
          end:
            '➦ Купи сега от онлайн магазин Хиполенд ✓ Бърза доставка в България ✓ Безплатна доставка над 65.00 лв. 02 / 40 484',
        },
        breadcrumbSentence: {
          start: 'Търсене за',
          end: '...',
        },
      },
      aggregates: [
        {
          label: 'Категории',
          aggregationType: AggregationTypeEnum.Terms,
          aggregationDefinition: 'categories',
          filterDefinition: 'category',
          order: 0,
          component: ComponentTypeEnum.Checkbox,
        },
        {
          label: 'Марки',
          aggregationType: AggregationTypeEnum.Terms,
          aggregationDefinition: 'brands',
          filterDefinition: 'brand',
          order: 1,
          component: ComponentTypeEnum.Autocomplete,
        },
        {
          label: 'Възраст',
          aggregationType: AggregationTypeEnum.Terms,
          aggregationDefinition: 'attr.age',
          filterDefinition: 'attr.age',
          order: 2,
          component: ComponentTypeEnum.AttributeCheckbox,
        },
        {
          label: 'Цена',
          aggregationType: AggregationTypeEnum.Ranges,
          aggregationDefinition: 'price:*-500,500-1000,1000-5000,5000-*',
          filterDefinition: 'price',
          order: 3,
          component: ComponentTypeEnum.RangeCheckbox,
        },
      ],
      notFound: ErrorPageData,
      SEO: {
        titleTemplate: ':name: | Търси | Онлайн Магазин — ХИПОЛЕНД',
        descriptionTemplate:
          'Търсиш :name::selected_filters:? ➦ Купи сега от онлайн магазин ✅ Хиполенд ✓ Бърза доставка в България ✓ Безплатна доставка над 65.00 лв. ☎ 02 / 40 484',
        favorDescriptionTemplateOverMeta: false,
        favorTitleTemplateOverMeta: false,
      },
    }),
    collection: ListingPageType.addTemplate('Collection', {
      sortOptions,
      defaultSortKey,
      labels: {
        filters: 'Филтри',
        selectedFiltersTitle: 'Избрани филтри',
        selectedFiltersBtnTxt: 'Изчисти',
        labelUnder: 'под',
        labelOver: 'над',
        labelBgn: 'лв',
        product: 'продукт',
        products: 'продукта',
        filterCallToAction: 'Филтрирай',
        sortCallToAction: 'Сортирай',
        searchingFor: 'за търсене по',
        searchIn: 'Търсете в',
        results: 'резултата',
        buyFromHippolandSentence: {
          start: 'Търсиш',
          end:
            '➦ Купи сега от онлайн магазин Хиполенд ✓ Бърза доставка в България ✓ Безплатна доставка над 65.00 лв. 02 / 40 484',
        },
        breadcrumbSentence: {
          start: 'Търсене за',
          end: '...',
        },
      },
      aggregates: [
        {
          label: 'Категории',
          aggregationType: AggregationTypeEnum.Terms,
          aggregationDefinition: 'categories',
          filterDefinition: 'category',
          order: 0,
          component: ComponentTypeEnum.Checkbox,
        },
        {
          label: 'Марки',
          aggregationType: AggregationTypeEnum.Terms,
          aggregationDefinition: 'brands',
          filterDefinition: 'brand',
          order: 1,
          component: ComponentTypeEnum.Autocomplete,
        },
        {
          label: 'Възраст',
          aggregationType: AggregationTypeEnum.Terms,
          aggregationDefinition: 'attr.age',
          filterDefinition: 'attr.age',
          order: 2,
          component: ComponentTypeEnum.AttributeCheckbox,
        },
        {
          label: 'Цена',
          aggregationType: AggregationTypeEnum.Ranges,
          aggregationDefinition: 'price:*-500,500-1000,1000-5000,5000-*',
          filterDefinition: 'price',
          order: 3,
          component: ComponentTypeEnum.RangeCheckbox,
        },
      ],
      notFound: ErrorPageData,
      SEO: {
        titleTemplate: ':name: | Играчки | Онлайн Магазин — ХИПОЛЕНД',
        descriptionTemplate:
          'Търсиш :name::selected_filters:? ➦ Купи сега от онлайн магазин ✅ Хиполенд ✓ Бърза доставка в България ✓ Безплатна доставка над 65.00 лв. ☎ 02 / 40 484',
        favorDescriptionTemplateOverMeta: false,
        favorTitleTemplateOverMeta: false,
      },
    }),
  },

  MenuLayoutTemplate: MenuLayoutType.addTemplate('MenuLayout', {
    menuItems: navbarData,
    footer: footerData,
    suggestedMenus: suggestedData,
    topStrip: [
      {
        value: 'Магазини',
        link: '/stores',
      },
      {
        value: 'Брошура',
        link: '/brochure',
      },
      {
        value: 'Контакти',
        link: '/contacts',
      },
    ],
    searchBox: {
      labels: {
        recentSearchesLabel: 'Последни търсения',
        popularSearchesLabel: 'Популярни търсения',
        suggestedBrandsLabel: 'Марки',
        suggestedCategoriesLabel: 'Категории',
        promoOffersLabel: 'Топ оферти',
        productsLabel: 'Продукти',
        blogLabel: 'В момента',
        blog: {
          blogTitle: 'Иновации от Хиполенд',
          image:
            'https://staging.balevbiomarket-contents.com/platform/media/BalevBio2.png',
          description:
            'Test Test Test Test Test Test Test Test Test Test Test Test Test Test Test Test Test Test Test Test ',
          url: '#',
        },
      },
      labelsColor: '#389361',
      textColor: '#000',
      priceColor: '#000',
      backgroundColor: '#fff',
      withRecent: true,
      withSuggested: true,
      bottomMenu: BottomMenuEnum.promo,
    },
    labels: {
      productsLabel: 'Продукти',
      brandsLabel: 'Марки',
      categoriesLabel: 'Категории',
      seeAllLabel: 'Виж всички',
      noResultsFound: 'Няма намерени резултати',
      search: 'Търсене',
      me: 'Аз',
      free: 'Безплатна',
      overPrice: 'над 65 лева',
      ariaLabelsAltsPlaceholders: {
        search: 'Търсене',
        location: 'Локация',
        favorites: 'Любими',
        basket: 'Кошница',
        logo: 'Лого',
        mainBanner: 'Главен банер',
      },
      categories: 'Категории',
      brandsAZ: 'Марки A-Z',
      myAccount: 'Моят Акаунт',
      favorites: 'Любими',
      basket: 'Кошница',
      info: 'Информация',
      stores: 'Магазини',
      phoneNumber: '02 / 40 484',
    },
  }),
  ProductsCarouselTemplate: ProductsCarouselType.addTemplate(
    'ProductsCarouselDefault',
    {
      isActive: true,
      heading: 'Топ оферти',
      viewAllLink: '/top-oferti/c',
      query: {
        limit: 10,
        filter:
          'sku;in;"086583","111869","124083","130145","134121","135770","131719","128218","137367","138640","136867","131713","073219","132840","134330"',
      },
    }
  ),
  SeoModuleTemplates: {
    index: SeoModuleType.addTemplate('Index', {
      title: 'Хиполенд',
      description:
        'В онлайн магазин Хиполенд ще намериш над 20000 артикула за бебета и деца: играчки, дрехи, обувки, колички, превозни средства и други. Купи онлайн!',
      keywords: 'играчки детски магазин',
    }),
  },
  ShopByAgeTemplate: ShopByAgeType.addTemplate('ShopByAgeDefault', {
    ...shopByAgeDefaultData,
    labels: { ariaAndAlt: '"Пазарувай по възраст"' },
  }),
}
